<template src="./FeedbackThankYou.html"></template>

<script>
import { formatDate } from "../utils/date";

export default {
  name: "FeedbackThankYou",

  props: {
    formTitle: { type: String, default: "" },
    fullName: { type: String, default: "" },
    prn: { type: String, default: "" },
    formType: { type: String, default: "" },
    submittedAt: { type: Date, default: null },
  },

  computed: {
    rows() {
      return [
        { label: "Feedback name", value: this.formTitle },
        { label: "Student name", value: this.fullName },
        { label: "PRN", value: this.prn },
        { label: "Feedback type", value: this.formType },
        { label: "Submission date", value: this.submissionDate },
        { label: "Submission time", value: this.submissionTime },
      ].filter((row) => row.value);
    },

    submissionDate() {
      return formatDate(this.submittedAt);
    },

    submissionTime() {
      if (!this.submittedAt) return "";
      return this.submittedAt.toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
      });
    },
  },
};
</script>

<style src="./FeedbackThankYou.css" scoped></style>
